import { OrgNode } from '../../../services/orgs/interfaces';

export const calculateEmptyFields = (org?: OrgNode): string[] => {
  const res: string[] = [];
  if (org?.fields.ein_number === undefined) {
    res.push('kybTaxId');
  }
  return res;
};

export const calculateInvalidFields = (org?: OrgNode): string[] => {
  const res: string[] = [];
  // if the org is missing the street value, the address is undefined
  if (org?.fields.street === undefined) {
    res.push('kybAddress');
  }
  return res;
};

export const calculateFieldsToLoad = (org?: OrgNode): string[] => {
  const res: string[] = [];
  if (org?.name !== undefined) {
    res.push('kybPayableName');
  }
  if (org?.fields.street !== undefined) {
    res.push('kybAddress');
  }
  if (org?.fields.ein_number !== undefined) {
    res.push('kybTaxId');
  }
  return res;
};
